<template>
  <router-link
    :to="{ name: 'Enquiry Overview', params: { id: enquiry.id } }"
    tag="div"
    class="enquiry-item"
    :class="dueStatus"
  >
    <div class="md-layout">
      <div class="md-layout-item md-size-20 customer">
        <router-link
          :to="{
            name: 'Customer Profile',
            params: { id: enquiry.customer.id }
          }"
          >{{ enquiry.customer.full_name }}</router-link
        >
      </div>
      <div class="md-layout-item md-size-10 heat" :class="ratingColour">
        <i v-for="(n, i) in enquiry.heat" :key="i" class="fas fa-star"></i>
      </div>
      <div class="md-layout-item md-size-20 follow-up">
        {{ enquiry.follow_up | formatDate }}
        <md-icon v-if="deferred">watch_later</md-icon>
      </div>
      <div class="md-layout-item md-size-20 manager">
        {{ enquiry.manager.full_name }}
      </div>
      <div class="md-layout-item md-size-20 tours">
        {{ tourTitle }}
      </div>
      <div class="md-layout-item md-size-10 actions text-right">
        <md-button
          :to="{ name: 'Enquiry Overview', params: { id: enquiry.id } }"
          class="md-success md-just-icon md-simple action-button"
        >
          <md-icon>visibility</md-icon>
          <md-tooltip md-direction="top">View Enquiry</md-tooltip>
        </md-button>
        <md-button
          class="md-danger md-just-icon md-simple action-button"
          @click.stop="deleteEnquiry(enquiry.id)"
        >
          <md-icon>delete</md-icon>
          <md-tooltip md-direction="top">Delete Enquiry</md-tooltip>
        </md-button>
      </div>
    </div>
  </router-link>
</template>

<script>
import moment from "moment";

export default {
  props: ["enquiry"],

  methods: {
    deleteEnquiry(enquiryId) {
      this.$emit("deleteEnquiry", { id: enquiryId });
    }
  },

  computed: {
    deferred() {
      return this.enquiry.status.value == "deferred";
    },

    tourTitle() {
      return this.enquiry.tours.map(tour => tour.title).join(", ");
    },

    ratingColour() {
      let temp = "";
      switch (this.enquiry.heat) {
        case 1:
        case 2:
          temp = "cool";
          break;
        case 3:
          temp = "medium";
          break;
        case 4:
        case 5:
          temp = "hot";
          break;
      }
      return temp;
    },

    dueStatus() {
      let followUp = moment(this.enquiry.follow_up, "YYYY-MM-DD");
      let current = moment().startOf("day");
      let days = moment.duration(followUp.diff(current)).asDays();

      let status = "";
      switch (true) {
        case days < 1:
          status = "overdue";
          break;
        case days < 7:
          status = "upcoming";
          break;
        default:
          status = "default";
          break;
      }

      return status;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
.enquiry-item {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #d2d2d2;

  cursor: pointer;

  .follow-up {
    border-radius: 10px;

    .md-icon {
      font-size: 19px !important;
      margin-left: 5px;
    }
  }
  &.overdue .follow-up {
    background-color: #f6acac;
  }
  &.upcoming .follow-up {
    background-color: #cef2d4;
  }
  &.default .follow-up {
    background-color: #f6f6f6;
  }

  .customer {
    font-weight: bold;
  }
  // .heat {
  //   font-size: 0.9em;
  //   &.cool {
  //     color: $brand-primary;
  //   }
  //   &.medium {
  //     color: $brand-warning;
  //   }
  //   &.hot {
  //     color: $brand-danger;
  //   }
  // }

  .actions {
    .action-button {
      width: 24px;
      min-width: 24px;
      height: 24px;
      margin: 0px;
    }
  }
}
</style>
